import { Session, session } from '../api'
import { useQuery } from '@tanstack/react-query'

export const useClientSession = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['userSession'],
    queryFn: async () => await session(),
    // Cache the data for 5 minutes
    staleTime: 5 * 60 * 1000,
    retryDelay: 10000,
    retry: 5
  })

  return {
    data,
    isAuthenticated: !!data?.accessToken,
    isLoading,
    error,
    refetch
  }
}
